import { toast } from "$global-providers/toast-provider";
import { Box, Button, Switch, TextField, Typography } from "@material-ui/core";
import { type FC, useState } from "react";
import { EPOCUS_TEXT_SECONDARY, rem } from "../../_lib/epocus-palette";
import { useUpdateMyEpocusUserMutation } from "./__generated__/epocus-settings-operations.gql";
import { SettingsCard, SettingsCardLabel } from "./settings-card";

export const ReminderEmailCard: FC<{
  reminderEmailEnabled: boolean;
  reminderEmailTime?: string | null;
}> = ({ reminderEmailEnabled, reminderEmailTime }) => {
  const [enabled, setEnabled] = useState(reminderEmailEnabled);
  const [time, setTime] = useState(reminderEmailTime ?? "");

  const [updateMyEpocusUser, { loading }] = useUpdateMyEpocusUserMutation({
    onCompleted: () => toast.success("Reminder email saved"),
    onError: (e) => toast.error(`Couldn't save: ${e.message}`),
  });

  return (
    <SettingsCard>
      <SettingsCardLabel>Reminder email</SettingsCardLabel>
      <Typography style={{ fontSize: rem(13), color: EPOCUS_TEXT_SECONDARY }}>
        A daily email when you have studies that aren't signed or are missing
        something billing needs. It shows counts only, never patient details.
      </Typography>

      <Box
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        style={{ gap: 12, minHeight: 40 }}
      >
        <Typography style={{ fontSize: rem(14) }}>
          Email me about unfinished studies
        </Typography>
        <Switch
          color="primary"
          checked={enabled}
          onChange={(event) => setEnabled(event.target.checked)}
          inputProps={{ "aria-label": "Email me about unfinished studies" }}
        />
      </Box>

      <TextField
        id="epocus-settings-reminder-email-time"
        variant="outlined"
        margin="dense"
        type="time"
        label="Send at"
        value={time}
        disabled={!enabled}
        onChange={(e) => setTime(e.target.value)}
        InputLabelProps={{ shrink: true }}
        helperText="In your program's time zone. Leave empty to use your program's send time."
        style={{ maxWidth: 320 }}
      />

      <Button
        variant="contained"
        color="primary"
        disabled={loading}
        style={{ alignSelf: "flex-end" }}
        onClick={() =>
          updateMyEpocusUser({
            variables: {
              input: {
                reminderEmailEnabled: enabled,
                reminderEmailTime: time || null,
              },
            },
          })
        }
      >
        Save
      </Button>
    </SettingsCard>
  );
};
